"use strict";

var conditions = require('./conditions');
/**
 * applyCondition takes a conditions and applies it to the shipment
 * @param {Shipment} shipment
 * @param {Object} condition
 * @param {String} condition.computer - 'match', 'notMatch' or 'boolean' (req'd)
 * @param {String} condition.key - shipment property (req'd)
 * @param {String} condition.value - desired value of property (req'd for 'match', defaults to true for boolean)
 * @returns {Boolean}
 * @example
 * const condition = {
 *   "computer": "match",
 *   "key": "service",
 *   "value": "priority"
 * };
 * const shipment = {
 *   service: 'Priority Mail',
 * }
 * applyCondition(shipment, condition) // => true
 *
 * @example
 * const condition = {
 *   "computer": "boolean",
 *   "key": "has_samples",
 * }
 * const shipment = {
 *   has_samples: false,
 * }
 * applyCondition(shipment, condition) // => false
 */


function applyCondition(shipment, condition) {
  var computer = condition.computer,
      key = condition.key;
  var value = condition.value || true;
  var f = conditions[computer];
  return f(shipment, key, value);
}

module.exports = applyCondition;